export const chapter5 = [

    //page 40
    'As they neared the southern reaches of Breglon the dirt path became wide,',
    'Dark-green shrubs and tall grasses covered all on the way up the hillside,',
    'By the time they came to the top, both of them were panting hard,',
    'They stopped to catch breath and for a moment let down their guard,',
    'Garson pointed to the distance, Breglon bridge was finally in sight,',
    'Slightly downhill now, they should be able to make it while still bright,',
    'They shared a smile and continued down the path it went winding,',
    'A strong wind blew and soon clouds hindered the sun from shining,',
    'The traveller‘s cloaks they were gifted did well to keep the cold air out,',
    'Sigg had been confident of no rain, but on that he now began to doubt,',

    //page 41
    'By the time the pair reached the stone bridge a light drizzle fell,',
    'They could see people standing upon it, one of them began to yell,',
    '“Pay the toll and soon you‘ll be inside with the warmth of a tavern fire”,',
    '“Refuse and unfortunately for you, you‘ll be in a position most dire”,',
    'Five brigands stood blocking the way with their knives glistening in the rain,',
    'Unbeknownst to them this pair was not going to be an easy monetary gain,',
    'Sigg whispered to Garson “Let’s not spill blood if it’s something we can avoid”,',
    '“I‘ll have something ready“ was the reply, these crooks had got him annoyed,',
    '“That‘s it yeah, come in close, this is just a business transaction”,',
    '“Give over half your stuff and there‘s no need for further action”,',
    'The tallest of the three seemed to be the leader of the bandit crew,',
    'Sigg scanned them and the area and thought of what he could do,',
    '“Are you willing to negotiate the terms to let us pass freely by?”,',
    '“Turn from your thieving ways now and no-one has to die”,',
    'The bandits cracked up laughing “Who do you think you are?!”,',
    '“Your words don‘t fool us, those capes are from down south, not far”,',
    'Sigg could feel his heart awaken in his chest, blood began to pump,',
    'It was clear to him now he‘d have to give a hard lesson to this chump,',
    'He threw his arms wide casting off his cloak and stood in battle stance,',
    'Before them a war-hardened tower of steel made them double glance,',

    //page 42
    '“I will break you upon this hammer and free this town of your grip!”,',
    'He bolted forth and swung his hammer and caught one on the lip,',
    'The bandit tumbled over backwards his haughty look now gone,',
    'Sigg thumped his hammer on his shield and roared “Bring it on!”,',
    'The bandits yelped, and swung their blades a fury, but with little skill,',
    'If Sigg wasn‘t so well armoured they would‘ve tallied up another kill,',
    '“Kill ‚em both!” One commanded as two more appeared carrying bows,',
    'Sigg went on the defensive after a dagger hilt smashed into his nose,',
    'The bandits loosed their arrows and were lined up for a kill they reckoned,',
    'Yet with expert martial skill Sigg deflected them both at the last second,',
    'Garson used their inattention on him to assemble a new battle device,',
    '“Experiment twenty-two!” He locked, loaded, aimed then fired it twice,',
    'The pair of bolts cut through the air, the bandit and got stuck deep in a tree,',
    'The other one carrying arrows and bow saw the carnage and began to flee,',
    'Sigg dodged, punched his shield into one dagger wielding felon,',
    'A fend and counter swing crushed the other‘s head like a melon,',
    'One landed a cut before the hammer came in for landing,',
    'Then a salvo of bolts impaled the other bandits still standing,',
    'A cheer erupted from some boys hiding on the far bank of the river,',
    'As the last brigand fell they emerged to meet their freedom giver,',

    //page 43
    '“Ha ha! Wow Misters! you sure showed them dirty, stealin‘ fools!”,',
    '“No more giving them our fish, money or listening to their rules!”,',
    'Sigg waved “Glad we could help, tell me is there more of this crew?”',
    'One boy piped up “Iron-jaw he‘s boss always telling ‚em what to do”,',
    '“And where is he now?” He replied as he wiped blood off his chin,',
    '“Normally he‘s drinking with those lot by the hearth at the town inn”,',
    'Garson loaded a few more bolts into his new favourite contraption,',
    'He muttered to himself as he improved it “I‘ll tighten this a fraction”,',
    '“Hey Sigg, come on, I‘ve had enough standing in the rain for one day”,',
    '“Follow us we‘ll make sure you have somewhere really nice to stay!”,',
    'The bridge unshackled once more as the victors strode across,',
    'They kept their weapons at hand expecting to see the bandit-boss,',
    'The downpour was set in now, everything felt weighted,',
    'The boys jumped in the puddles, happy to be liberated, ',
    '“Wait out here“ Garson directed, “Stay clear until its secure”,',
    'The boys nodded and grinned “You‘ll kill him, I‘m sure!”,',
    '“Ready Garson?” Sigg checked, one hand on the wooden door handle,',
    'Garson nodded, they burst in to find a large hall lit by many a candle,',
    'It was packed with local patrons each with a jug in their hand,',
    'Sigg knew that many could be hurt if they were not well-planned,',
    '“Iron-jaw! Come out! You‘re reign here has come to a close!”,',
    'All in the tavern was startled by this stranger and many froze,',

    //page 44
    'The moment passed awkwardly as Garson trained his weapon around,',
    'After no response to their call and further searching he wasn‘t found,',
    '“Sigg is that you?” A voice called out from by the fireplace,',
    'The two newcomers were surprized to see a familiar face,',
    '“Eanom? You weren‘t killed in the fire at Sutha‘s northern gate?”,',
    '“What fire? I left there days ago to escort a trader who was late”,',
    '“Anyway, Iron-jaw hasn‘t been here for a few days or more”,',
    '“I‘ve heard of him from the villagers, they sure do abhor”,',
    '“Do you think soon he‘ll be coming back?”,',
    '“No idea, relax you‘re not under attack”,',
    'The rest of the patrons returned to their drink,',
    'Sigg and Garson disarmed and had time to think,',
    'Eanom beckoned them over, “Come try some of the stew”,',
    '“I don‘t think you‘ll need to worry about you-know-who”,',
    'They all ate and drank no longer needing to fight,',
    'After spending a few coins they slept there the night,',
    'At first light Sigg was again ready to travel and knocked on Garson‘s door,',
    '“I‘m heading off to Cragknoll now, home‘s call is something I can‘t ignore”,',
    '“Someday I‘d like to catch up again, some place where we‘ll be well-fed,',
    '“All the best for your travels Sigg!” Garson waved and rolled over in bed,',
    '“Agreed! fare well,” Sigg left the tavern and found the path leading west,',
    'Of all the cardinal directions he knew that this one was by far the best,',

    //page 45
    '“Next stop Cragknoll!” Finally, he was able to declare those sweet words,',
    'The rains had moved on overnight, all was still other than singing birds,',
    'It did not bother him that the sky was grey,',
    'He had an extra spring in his step today,',
    'As he walked Sigg imagined his victorious return,',
    'It felt good to be near to what his heart did yearn,',
    'The dirt path was poorly kept it had got little use of late,',
    'It wound its way to the side of the river and was rarely straight,',
    'Sigg examined in his hands the precious hammer long been lost,',
    'It had been so long since he‘d been home, but it was worth the cost,',
    'He walked all morning and did not stop to eat,',
    'Sigg willed his body on and kept moving his feet,',
    'Up ahead he could see the outer pine wood,',
    'On the other side was home, it sure felt good,',
    'The path led him deep into the old trees so tall,',
    'This was as far as he‘d ventured when he was small,',
    'The smell of pine-needles brought back memories long buried,',
    'A simpler time with toys and only wooden weapons carried,',
    'Sigg smiled as the trees finally gave way to low laying bush,',
    'He was nearly there he just needed to make the final push,',
    'There at the end of the path stood a tall gate and wall of round-pole,',
    'This was it Sigg had finally made it back to his home of Cragknoll!',

    //page 46
    'As he drew closer, he walked past the old graves and stones of tomb,',
    'They were still cared for years later many laden with flowers in bloom,',
    'Sigg walked up to the closed gate and called up to the guard tower,',
    '“Open up! I‘m home, oh I‘ve been so looking forward to this hour”,',
    'A young guard drew his bow and peered down at Sigg “Who are you?”,',
    'A little insulted he called back “I‘m Sigg our WarScholar, you know what to do”,',
    'But instead of opening the gate he wore a suspicious look and rang the bell,',
    '“Good, call the guard captain and of a poor job you‘re doing I can him tell”,',
    'Sigg tried to open the gate it was locked up tight,',
    '“Back up now!” The guard called ready for a fight,',
    'Soon a few more guards appeared above the gate battle ready,',
    'An older one commanded “Just back it up there, nice and steady”,',
    'Without active thought Sigg‘s WarScholar skills kicked into gear,',
    'He identified a weakness in the gate hinges, damage would be severe,',
    '“No! Can‘t you see I‘m clad in Cragknollian armour and crest?”,',
    '“I‘ve been gone a long time, but I‘m now back from my quest”,',
    'Sigg angrily held up the revered hammer for all to see,',
    '“This is one of the lost founding weapons you must agree!”',
    'At this the older guard shouted to all those behind him,',
    '“Bring Teelu right now!” he stared at Sigg with face grim,',

    //page 47
    'Sigg was confused “What is going on? why bring Teelu so little?”,',
    'He was getting mad now and when he spoke he sprayed spittle,',
    '“She‘ll tell you, I fought with her father in northern field”,',
    'More guards drew their bows and kept their eyes peeled,',
    'He took a double take as Teelu stepped into view,',
    'She had aged a dozen years, but it was somehow true,',
    'She spoke with authority as her voice rang out clear,',
    'The Cragknollian chief emblem donned the top of her spear,',
    '“Stranger, you claim to be a man long since dead”,',
    '“Move slowly now or arrows will fill your lying head”,',
    'Sigg‘s brain was now starting to spin out of control,',
    'Had so many battles really taken such a heavy toll?',
    'He took off his helmet and showed all his face,',
    '“It’s me! Take a good look“ he said just in case,',
    'Teelu leaned out and peered with discerning eyes,',
    'No longer the girl he knew, but honoured and wise,',
    '“Recite the oath and perhaps your words are true after all”,',
    'Sigg spoke the holy words to the best that he could recall,',
    '“You may be who you claim, but still these gates will remain shut”,',
    'These words hurt Sigg more than a heavy blow to the gut,',
    '“Cragknoll does not have a ‚WarScholar‘ that which you claim”,',
    '“What is worse is the dishonour shackled to your name”,',

    //page 48
    'Sigg was speechless, how could they say that and mean it?',
    'Was there really a word or two in the oath he did in fact omit?',
    '“Long ago Sigg from Cragknoll was part of a large battle”,',
    '“His mind was broken we thought he‘d cried death‘s rattle”,',
    '“When our vile enemy was upon us you submitted to his word”,',
    '“Despite being raised here you attacked your fellow with your sword”,',
    '“No! Lies! I cannot hear any more of this, can‘t you see it’s me?!”,',
    'Sigg cried at the top of his lungs and pleaded desperately,',
    'Teelu whispered quietly to other elders by her side,',
    'The decision made now Sigg would have to abide,',
    '“You will not be killed today, this is the most I can do”,',
    '“But I would never come this way again if I was you”,',
    '“Sigg ‚WarScholar‘ you are henceforth banished for life”,',
    'These word wounded deeper than a cut of hunting knife,',
    '“But, but, the relic hammer! I brought it all the way back!”,',
    '“Quiet! one more step and we‘ll have no choice but to attack!”,',
    '“Go find every lost artefact only then I will your words hear”,',
    '“If you want to keep your life go now, hurry disappear!”,',
    'Tears ran down Sigg‘s cheeks this heartbreak was too much,',
    'His breathing became rapid, his hands were cold to the touch,',
    '“I now make this solemn vow I will bring them all back”,',
    '“I bind myself to this promise forever lest my life I lack”,',

    //page 49
    'Teelu looked on in pity and an idea came to her mind,',
    '“Is it possible that you‘re still somehow spell-entwined?”,',
    'She channelled her focus and spoke aloud magic words to purify,',
    'A bolt of light sped from her hands and Sigg‘s mind began to fry,',
    'The mind-curse was finally ruptured as he couldn‘t help but scream,',
    'His lost memories returned to him, as if awaking from a dark dream,',
    'Sigg roared a haunting cry that made some shiver,',
    'He managed a thankful nod to his mind-freedom giver,',
    'He stood up and staggered back towards the wood,',
    'Sigg had to focus on small things the best that he could,',
    'Walking away from Cragknoll gates he set the hammer down,',
    'Upon the grave of its original owner from his loved hometown,',
    'He held his head in his hands and tried to slow his breath,',
    'It took all his resolve not to escape into the embrace of death,',
    'Memories of fighting alongside Cragknoll guards pierced his brain,',
    'He remembered charging at a sorcerer then enormous internal pain,',
    'Despite his will resisting, he cut down his fellow guards,',
    'His mind was shattered and tumbled like a house of cards,',
    'If life could be distilled to a roll of chance it‘d be a one in twenty,',
    'Instead of his mind broken for time it became years in plenty,',
    'Sigg was tasked at learning every advantage that could be in war,',
    'In his mind he was a WarScholar and he believed it to his core,',

    //page 50
    'After the tragic battle somehow he wandered off alone,',
    'The next morning he awoke as if it was all he had known,',
    'So for years he continued on learning, searching and fighting,',
    'He collected tactics, strategies and recorded it all in writing,',
    'With teary eyes he drew out from under armour his notebook,',
    'He flicked through the pages yearning for meaning with each look,',
    'He continued walking to where he did not know,',
    'Sigg felt like he was drowning in cursed woe,',









];